//-------------------------\\
//---- Classe Parallax ----\\
//-------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Classe permettant d'ajouter des éléments parallax sur une page à l'aide de data dans le code HTML
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
import Scrollbar from 'smooth-scrollbar'
import { isIE } from './../functions/helper.js'
//-----------------------------------------------------------------------------------------------------------------

export class Parallax {

  constructor() {
    this.tElements = [].slice.call(document.querySelectorAll('[data-parallax]'))
    this.tReferences = []
    this.elementOffset = ''
    this.centreEcran = ''
    this.centreElement = ''
    this.position = ''
    this.mediaQuery = 1300
    this.init()
  }


  init() {
    if(!isIE()) {
      var self = this

      this.tElements.forEach((e, index) => {
        this.tReferences.push({ e, reference() { self.parallax(e, index) }})
      })

      this.tReferences.forEach((e) => {
        e.reference()
        this.addScrollEvent(e.reference)
        addEventListener('DOMContentLoaded', e.reference, false)
        addEventListener('load', e.reference, false)
        addEventListener('resize', e.reference, false)
      })
    }
  }

  update() {
    if(!isIE()) {
      var self = this

      this.tElements = [].slice.call(document.querySelectorAll('[data-parallax]'))
      this.tElements.forEach((e) => { e.style.transform = 'none' })
      this.tReferences = []

      this.tElements.forEach((e, index) => {
        this.tReferences.push({ e, reference() { self.parallax(e, index) }})
      })

      this.tReferences.forEach((e) => {
        e.reference()
        this.addScrollEvent(e.reference)
      })
    }
  }


  // Permet de détruire tout ce que la classe à initialisé
  destroy() {
    if(!isIE()) {
      this.tElements.forEach((e) => { e.style.transform = 'none' })
      this.tReferences.forEach((e) => {
        this.removeScrollEvent(e.reference)
        removeEventListener('DOMContentLoaded', e.reference, false)
        removeEventListener('load', e.reference, false)
        removeEventListener('resize', e.reference, false)
      })
      this.tElements   = []
      this.tReferences = []
    }
  }
  

  // Détect si l'élément est visible dans le viewport
  parallax(e) {
    var old_visible = false
    var visible     = this.isElementInViewport(e)
    var offset      = parseInt(( e.dataset.offset !== undefined ? e.dataset.offset : 0 ))

    if ( window.innerWidth >= this.mediaQuery) {
      if (visible != old_visible) {
        old_visible = visible
        this.elementOffset = e.getBoundingClientRect().top
        this.centreEcran = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) + (window.innerHeight / 2)
        this.centreElement = this.elementOffset + ( e.clientHeight / 2 )
        this.position = this.centreEcran - this.centreElement
        e.style.transform = 'translateY(' + ( this.position * (e.dataset.speed / 10) + offset) + 'px)'
      }
    } else {
      e.style.transform = 'none'
      this.removeScrollEvent(e.reference)
      removeEventListener('DOMContentLoaded', e.reference, false)
      removeEventListener('load', e.reference, false)
      removeEventListener('resize', e.reference, false)
    }
  }


  // Retourne la condition indiquand si l'élément est visible dans le viewport ou pas
  isElementInViewport(e) {
    var rect = e.getBoundingClientRect()

    return (
      rect.bottom >= 0 &&
      rect.right  >= 0 &&
      rect.top    <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left   <= (window.innerWidth  || document.documentElement.clientWidth)
    )
  }


  // Utilisé pour ajouter un événement de scroll sur le plugin smooth scrollbar ou bien le scroll natif
  addScrollEvent(myFunction) {
    if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
      window.mainScrollbar.addListener(myFunction)
    } else {
      $(document).on('scroll', myFunction)
    }
  }


  // Utilisé pour retirer un événement de scroll sur le plugin smooth scrollbar ou bien le scroll natif
  removeScrollEvent(myFunction) {
    if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
      window.mainScrollbar.removeListener(myFunction)
    } else {
      $(document).off('scroll', myFunction)
    }
  }
}